import React, { Component } from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import { translationHook } from "../../../translationHook";
import { Form } from "react-final-form";
import { TextField, Switches } from "mui-rff";
import apiConfig from "../../../../apis/apiConfig";
import { validateDonationSideData } from "../../../../apis/charity/donationSides/validateDonationSideData";

import { ButtonPrimary } from "../../../UI/Buttons";
import { setLoading, triggerNotification, triggerDialogForm } from "../../../../actions";

class SideForm extends Component {
    constructor(props) {
		super(props);
		this.state = {
			showForm: false,
		};
	}

    handleSubmit = async (values, form) => {
		const at = this.props.currentUser.Data.access_token,
			url = this.props.editMood
				? "/API/CHARITY/LOOKUPS/Donations_Sides/Update_Donation_Side"
				: "/API/CHARITY/LOOKUPS/Donations_Sides/Add_Donation_Side";
		let body = {
			...values,
			Active_Status_Id: values.Active_Status_Id ? 1 : 0,
			IS_External_Initiative: values.IS_External_Initiative ? 1 : 0,
		};

		if (this.props.editMood) {
			body = { Donation_Side_Id: this.props.donationSideId, ...body };
		}

		this.props.setLoading(true, "dark");

		const response = await apiConfig
			.post(url, body, {
				headers: {
					Authorization: `Bearer ${at}`,
				},
			})
			.catch((error) => {
				return error.response;
			});

		if (response.data.Status) {
			form.restart();
		}

		if (this.props.editMood) {
			this.props.triggerDialogForm(false);
		}

		this.props.triggerNotification(true, response.data);

		this.props.setLoading(false);

		if (this.props.submitCB) {
			this.props.submitCB();
		}
	};

    render() {
		let { initValues } = this.props;

        const validate = async (values) => {
            const errors = {};
            const at = this.props.currentUser.Data.access_token;

            await validateDonationSideData(at, values).then((res) => {
                if (res?.Data?.Validation_Results_List?.length) {
                    res?.Data?.Validation_Results_List.forEach((f) => {
                        if (!f.Result) {
                            errors[f.Input_Name] =
                                this.props.i18n.language === "ar"
                                    ? f.Error_AR
                                    : f.Error_EN;
                        }
                    });
                }
            });

            return errors;
        };

        return (
            <>
                {!this.props.editMood && !this.props.viewMood && (
                    <div className="d-flex justify-content-between align-items-center pb-5">
                        <h3>{this.props.t("donationsSidesList")}</h3>
                        <ButtonPrimary
                            variant={
                                !this.state.showForm ? "contained" : "outlined"
                            }
                            onClick={() =>
                                this.setState({
                                    showForm: !this.state.showForm,
                                })
                            }
                        >
                            {!this.state.showForm && this.props.t("addDonationSide")}
                            {this.state.showForm && this.props.t("cancel")}
                        </ButtonPrimary>
                    </div>
                )} 

                <Form
                    validateOnBlur={true}
                    subscription={{ submitting: true }}
                    onSubmit={this.handleSubmit}
                    initialValues={
                        initValues
                            ? initValues
                            : {
                                    Active_Status_Id: 1,
                                    Donation_Side_Name_AR: "",
                                    Donation_Side_Name_EN: "",
                                    Start_Balance_Value: "",
                                    IS_External_Initiative: 1
                                }
                    }
                    validate={validate}
                    render={({ handleSubmit, form, submitting }) => (
                        <form
							className={`row pt-5 px-3 ${
								!this.state.showForm &&
								!this.props.editMood &&
								!this.props.viewMood
									? "d-none"
									: ""
							}`}
							onSubmit={handleSubmit}
							noValidate
						>
                            <Col xs={12} md={6}>
                                <TextField
                                    disabled
                                    label={this.props.t("idNo")}
                                    className={`read-only mb-2`}
                                    name="Donation_Side_Id"
                                    autoComplete="off"
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("startBalance")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    name="Start_Balance_Value"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("nameAr")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    required={true}
                                    name="Donation_Side_Name_AR"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col xs={12} md={6}>
                                <TextField
                                    disabled={this.props.viewMood}
                                    label={this.props.t("nameEn")}
                                    className={`${this.props.viewMood ? "read-only" : ""} mb-2`}
                                    required={true}
                                    name="Donation_Side_Name_EN"
                                    autoComplete="off"
                                    showError={({
                                        meta: {
                                            submitFailed,
                                            invalid,
                                            touched,
                                        },
                                    }) => {
                                        return touched && invalid;
                                    }}
                                />
                            </Col>

                            <Col
                                xs={12}
                                md={2}
                                className={`${
                                    this.props.viewMood ? "read-only" : ""
                                }`}
                            >
                                <Switches
                                    disabled={this.props.viewMood}
                                    color="primary"
                                    name="Active_Status_Id"
                                    data={{
                                        label: `${this.props.t(
                                            "serviceStatus"
                                        )}`,
                                        defaultValue: `${this.props.t(
                                            "serviceStatus"
                                        )}`,
                                    }}
                                />
                            </Col>

                            <Col
                                xs={12}
                                md={2}
                                className={`${
                                    this.props.viewMood ? "read-only" : ""
                                }`}
                            >
                                <Switches
                                    disabled={this.props.viewMood}
                                    color="primary"
                                    name="IS_External_Initiative"
                                    data={{
                                        label: `${this.props.t(
                                            "externalInitiative"
                                        )}`,
                                        defaultValue: `${this.props.t(
                                            "externalInitiative"
                                        )}`,
                                    }}
                                />
                            </Col>

                            <Col
                                className="my-4 justify-content-start d-flex"
                                xs={12}
                            >
                                {!this.props.viewMood && (
                                    <ButtonPrimary
                                        color="primary"
                                        variant="contained"
                                        disabled={
                                            submitting || this.props.viewMood
                                        }
                                        type="submit"
                                    >
                                        {this.props.t("save")}
                                    </ButtonPrimary>
                                )}
                            </Col>
                        </form>
                    )}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return { currentUser: state.currentUser };
};

export default connect(mapStateToProps, {
    triggerNotification,
    setLoading,
    triggerDialogForm,
})(translationHook(SideForm));